import { render, staticRenderFns } from "./LocationBox.vue?vue&type=template&id=7638d413&"
import script from "./LocationBox.vue?vue&type=script&lang=js&"
export * from "./LocationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports